export enum TagsTypes{
    OKR = "1",
    INDICATORS = "2",
    ACTIONS = "3",
    OCCURRENCES = "4",
    AUDITS = "5",
    RISKS = "6",
    MEETINGS = "7",
    PROJECTS = "8",
    MAPS = "9"
}

export interface ITags{
    taa014Id: number;
    taa014Descricao: string;
}

export interface IRefFiltersTagsContainer{
    response: string;
}

export interface IFiltersTagsContainer{
    onSubmitFilters: () => void;
    tagType: TagsTypes;
    showFilters?: boolean;
    defaultValue?: number[];
}
